// removed by extract-text-webpack-plugin
module.exports = {"orderOverview":"summary-controls---orderOverview---2dkZE","font16":"summary-controls---font16---2sKyl","p":"summary-controls---p---3Qkb7","aTag":"summary-controls---aTag---ACVTg","infoBox":"summary-controls---infoBox---34pBI","infoBoxIcon":"summary-controls---infoBoxIcon---3bQgM","detailsList":"summary-controls---detailsList---337ds","priceTotal":"summary-controls---priceTotal---hJg0i","buttonCss":"summary-controls---buttonCss---3onid"};;
    if (module.hot) {
      var injectCss = function injectCss(prev, href) {
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = href;
        link.onload = function() {
          document.head.removeChild(prev);
        };
        document.head.appendChild(link);
      };
      module.hot.dispose(function() {
        window.__webpack_reload_css__ = true;
      });
      if (window.__webpack_reload_css__) {
        module.hot.__webpack_reload_css__ = false;
        console.log("[HMR] Reloading stylesheets...");
        var prefix = document.location.protocol + '//' + document.location.host;
        document
          .querySelectorAll("link[href][rel=stylesheet]")
          .forEach(function(link) {
            if (!link.href.match(prefix)) return;
            injectCss(link, link.href.split("?")[0] + "?unix=1789047462631");
          });
      }
    }
  